/*
 * File: c:\Users\j.mazat\Desktop\AutobuyBackOffice\AutobuyBackOffice\src\Config\Router\RouterPathResolver.ts
 * Project: c:\Users\j.mazat\Desktop\AutobuyBackOffice\AutobuyBackOffice
 * Created Date: Tuesday June 6th 2023
 * Author: Jonathan Mazat
 * -----
 * Last Modified: Wednesday, 23rd October 2024 03:57:10
 * Modified By: Simon (s.gourlet@autobuy.fr>)
 * -----
 * Copyright (c) 2023 Autobuy SAS
 * -----
 */

import { RouterPathResolverType } from "Config/Router/RouterPathResolver.type";

/**
 * Router description of all the different paths
 */
const RouterPathResolver: RouterPathResolverType = {
  // Do not change the next line, configure it via the ROUTE_BY_ROLES above
  pathCar_Client: { path: "https://www.mobyfleet.fr/car/:id" },
  pathEntryPoint: { path: "/" },
  pathHome: { path: "/" },
  pathLogin: { path: "/login" },
  pathUser: { path: "/users" },
  pathMyUser: { path: "/my_users" },
  pathMyCompany: { path: "/my_company" },
  pathUser_BY_ID: { path: "/users/:id" },
  pathGroups: { path: "/groups" },
  pathGroups_BY_ID: { path: "/groups/:id" },
  pathPartners: { path: "/partners" },
  pathPartners_BY_ID: { path: "/partners/:id" },
  pathParks: { path: "/parks" },
  pathCompanies: { path: "/companies" },
  pathCompany_BY_ID: { path: "/companies/:id" },
  pathPack: { path: "/packs" },
  pathPack_BY_ID: { path: "/packs/:id" },
  pathSell: { path: "/sells" },
  pathCarrier: { path: "/carriers" },
  pathSell_BY_ID: { path: "/sells/:id" },
  pathCar: { path: "/cars" },
  pathCar_BY_ID: { path: "/cars/:id" },
  pathMessage: { path: "/messages" },
  pathVisuals: { path: "/visuals" },
  pathLanguages: { path: "/languages" },
  pathStats: { path: "/stats" },
  pathOffers: { path: "/offers" },
};

export default RouterPathResolver;
